// The wordmark, one treatment everywhere.
//
// Four stages had four slightly different versions of "WINDTUNNEL" in the corner — different sizes,
// different tracking, one with a separator and one without. It is the only piece of branding in the
// interface, so it is worth it being the same object each time you see it.
//
// The mark is the same cyan rectangle frame as the favicon: a window onto a piece of ground, drawn as a
// control measure would be. `size="bar"` is the stage top bars, `size="page"` is the title block on the
// scenario stage and the design record.

export function Wordmark({
  size = 'bar', suffix, className,
}: {
  size?: 'bar' | 'page';
  /** A second word after a thin separator, e.g. "PLANNING" or "DEBRIEF". */
  suffix?: string;
  className?: string;
}) {
  const page = size === 'page';
  const box = page ? 13 : 10;
  return (
    <span
      data-testid="wordmark"
      className={`mono inline-flex shrink-0 items-center whitespace-nowrap ${page ? 'gap-2' : 'gap-1.5'} ${className ?? ''}`}
    >
      <svg width={box} height={box} viewBox="0 0 16 16" aria-hidden focusable="false">
        <rect
          x="1.25" y="1.25" width="13.5" height="13.5"
          fill="none" stroke="var(--color-friendly)" strokeWidth="1.5"
        />
        <rect x="6" y="6" width="4" height="4" fill="var(--color-friendly)" />
      </svg>
      <span
        className={page ? 'text-[12px] tracking-[0.42em] text-paper' : 'text-[10px] tracking-[0.3em] text-fog'}
      >
        WINDTUNNEL
      </span>
      {suffix && (
        <>
          <span className="text-[10px] text-slate-700" aria-hidden>·</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-fog">{suffix}</span>
        </>
      )}
    </span>
  );
}
